import { get } from '@otto-ec/global-resources/fragment';
import { mount } from 'svelte';
import UpsellingComponent from './component/UpsellingComponent.svelte';
import OnexE3452Group from './api/OnexE3452Group';
import type UpsellingComponentProps from './component/UpsellingComponentProps';

export default (id: string, onexE3452Group?: OnexE3452Group) => {
  const variationId = get('variationId');
  const variationIdAsString = variationId ? `${variationId}` : undefined;

  const target = document.getElementById(id)!;
  mount<UpsellingComponentProps, object>(
    UpsellingComponent,
    { target, props: { variationId: variationIdAsString, onexE3452Group } },
  );
};
